// src/components/I18nText.tsx
import React from 'react'
import { Trans, TransProps } from 'react-i18next'
import { TranslationKeys } from '../../useTranslation'

const I18nText: React.FC<TransProps<TranslationKeys>> = ({ children, ...props }) => {
    // Add any custom logic or styling here
    return <Trans {...props}>{children}</Trans>
}

export default I18nText
